// extracted by mini-css-extract-plugin
export var icon = "_56-1";
export var subtext = "_56-0";